import VerificationCard from './VerificationCard';

export default VerificationCard;
